<template>
  <div class="switcher-fontsize">
    <v-btn 
      v-if="getFontSize === 1"
      @click="handleFlipResizeClick(2)"
      icon="mdi mdi-format-font-size-increase" 
      variant="text"
      title="Zmień rozmiar czcionki na domyślny">
    </v-btn>
    <v-btn 
      v-if="getFontSize === 2"
      @click="handleFlipResizeClick(3)"
      icon="mdi mdi-format-font-size-increase" 
      variant="text"
      title="Zmień rozmiar czcionki na większy">
    </v-btn>
    <v-btn 
      v-if="getFontSize === 3"
      @click="handleFlipResizeClick(1)"
      icon="mdi mdi-format-font-size-decrease" 
      variant="text"
      title="Zmień rozmiar czcionki na większy">
    </v-btn>
  </div>
</template>


<script lang="ts">
/*eslint-disable */
/* tslint:disable */
import { computed, defineComponent, Ref } from 'vue';
import store                              from '@/store';


const FontsizeSwitcher: object = defineComponent({
  name: 'FontsizeSwitcher',
  props: {
    icon: {
      type: String,
      // eslint-disable-next-line global-require
      default: require('@/assets/img/top_icons/svg/icon-fontsize-white.svg'),
    },
    iconhc: {
      type: String,
      // eslint-disable-next-line global-require
      default: require('@/assets/img/top_icons/svg/icon-fontsize-yellow2.svg'),
    },
  },
  setup() {
    const getFontSize: Ref<number> = computed((): number => store.getters.getFlipResizeActive);
    const handleFlipResizeClick = (item: number) => {
      store.commit('flipResizeFont', item);
    };

    return {
      getFontSize,
      handleFlipResizeClick,
    };
  },
});
export default FontsizeSwitcher;
</script>


<style scoped lang="scss">

.switcher-fontsize {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;
  transition: transform ease-in-out 0.3s,
  opacity ease-in-out 0.3s;
  box-sizing: border-box;
}
</style>
